import '../App.css';
import { useEffect, useMemo, useState } from 'react';
import throttle from 'lodash/throttle';

import PropTypes from 'prop-types';
import Paper from '@mui/material/Paper';
import Slider from '@mui/material/Slider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { styled } from '@mui/material/styles';
import { DataGrid } from '@mui/x-data-grid';
import Link from '@mui/material/Link';

import { binary_search, gameTypesAvailable } from '../util.ts'

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

var columnsPlayers: GridColDef[] = [
  { field: 'player', headerName: 'Player', width: 200,
    renderCell: (params) => {
      return (
        <Link target="_blank" href={`http://zero-k.info/Users/Detail/${params.value.id}`}>{params.value.nickname}</Link>
        )
    },

  },
  { field: 'won', headerName: 'Won', width: 120 },
  { field: 'lost', headerName: 'Lost', width: 120 },
  { field: 'ratio', headerName: 'Ratio (%)', width: 150, type: "number", },
];

var columnsMaps: GridColDef[] = [
  { field: 'map', headerName: 'Map', width: 200,
    renderCell: (params) => (
      <Link target="_blank" href={`http://zero-k.info/Maps/Detail/${params.value.link}`}>{params.value.name}</Link>
  )},
  { field: 'won', headerName: 'Won', width: 120 },
  { field: 'lost', headerName: 'Lost', width: 120 },
  { field: 'ratio', headerName: 'Ratio (%)', width: 150,  type: "number", },
];

function PlayerCorrelation(props) {
  const filterBar = props.filterBarValues;

  const [minimumGamesMaps, setMinimumGamesMaps] = useState(1);
  const [minimumGamesMapsDisplay, setMinimumGamesMapsDisplay] = useState(0);
  const [maximumGamesMaps, setMaximumGamesMaps] = useState(1000);

  const [minimumGamesPlayersTeammates, setMinimumGamesPlayersTeammates] = useState(0);
  const [minimumGamesPlayersTeammatesDisplay, setMinimumGamesPlayersTeammatesDisplay] = useState(1);
  const [maximumGamesPlayersTeammates, setMaximumGamesPlayersTeammates] = useState(1000);

  const [minimumGamesPlayersEnemies, setMinimumGamesPlayersEnemies] = useState(0);
  const [minimumGamesPlayersEnemiesDisplay, setMinimumGamesPlayersEnemiesDisplay] = useState(1);
  const [maximumGamesPlayersEnemies, setMaximumGamesPlayersEnemies] = useState(1000);


  const [rowsMaps, setRowsMaps] = useState([]);
  const [rowsPlayersTeammates, setRowsPlayersTeammates] = useState([]);
  const [rowsPlayersEnemies, setRowsPlayersEnemies] = useState([]);

  const [playerWonLost, setPlayerWonLost] = useState("");

  useEffect(() => {
    var i;
    if(Object.keys(filterBar).length>0) {
      var processingStartTimeFirst = Date.now();

      props.jsonPlayers.min = binary_search(props.jsonPlayers.first_battle_sec, (Math.round(Date.now() / 1000) - 3600*24*filterBar.accountAgeRangeDays[1]), false, true);
      props.jsonPlayers.max = binary_search(props.jsonPlayers.first_battle_sec, (Math.round(Date.now() / 1000) - 3600*24*filterBar.accountAgeRangeDays[0]), true, false);

      const player_id_min = props.jsonPlayers.player_id[props.jsonPlayers.min];
      const player_id_max = props.jsonPlayers.player_id[props.jsonPlayers.max];

      props.jsonBattles.min = binary_search(props.jsonBattles.started_sec, (filterBar.startDate/1000), false, true);
      props.jsonBattles.max = binary_search(props.jsonBattles.started_sec, (filterBar.endDate/1000), true, false);

      // Dictionary with keys map id-s and values {"won":X,"lost":Z}
      var mapAssociation = {};

      // Dictionary with keys map id-s and values {"won":X,"lost":Z}
      var playerAssociation = {};
      var playerAssociationEnemy = {};

      var gamesIds = filterBar.gamesChecked;

      var count_maps = 0;
      var count_battles = 0;
      var count_player = 0;

      for(i=props.jsonBattles.min; i<=props.jsonBattles.max; i++) {
        var gameTypeOk = false;
        var j;
        for(j=0;j<filterBar.gameTypesChecked.length;j++) {
          if(filterBar.gameTypesChecked[j] && gameTypesAvailable[j].func_filter(props.jsonBattles,i)) {
            gameTypeOk = true;
            break;
          }
        }
        if(!gameTypeOk) {
          continue;
        }

        if(!gamesIds.includes(props.jsonBattles.game_id[i])) {
          continue;
        };

        const map_idx = binary_search(props.jsonMaps.map_id, props.jsonBattles.map_id[i]);

        if(!filterBar.mapTypeAvailableChecked.map((elem, j) =>
            (!elem || filterBar.mapTypeAvailable[j]['value'] === props.jsonMaps[filterBar.mapTypeAvailable[j]['column']][map_idx])).every((x)=>x)) {
              continue;
        }
        var area = props.jsonMaps.size_x[map_idx]*props.jsonMaps.size_y[map_idx];
        if(area<filterBar.mapSize[0] || filterBar.mapSize[1]<area) {
          continue;
        }

        count_maps++;

        const battle_player_idx_first = binary_search(props.jsonBattlePlayer.battle_id, props.jsonBattles.battle_id[i], true, false, true);
        var playersFound = false;
        var battle_player_idx = battle_player_idx_first;
        var player_team;
        while(props.jsonBattlePlayer.battle_id[battle_player_idx] === props.jsonBattles.battle_id[i]) {
          // TODO: option to do both filter and player age
       	  // if (props.jsonBattlePlayer.player_id[battle_player_idx] < player_id_min ||
          //     player_id_max < props.jsonBattlePlayer.player_id[battle_player_idx]) {
         	// 		break;
          // }

          if (props.jsonBattlePlayer.player_id[battle_player_idx] === filterBar.playerId) {
            playersFound = true;
            player_team = props.jsonBattlePlayer.team_id[battle_player_idx] ;
            var mapAssociationPlayerMap = mapAssociation[props.jsonBattles.map_id[i]];
            if(!mapAssociationPlayerMap) {
              mapAssociationPlayerMap = {"won":0,"lost":0};
              mapAssociation[props.jsonBattles.map_id[i]] = mapAssociationPlayerMap;
            }
            if (props.jsonBattlePlayer.team_id[battle_player_idx] === props.jsonBattles.team_won[i]) {
              mapAssociationPlayerMap["won"]++;
            } else {
              mapAssociationPlayerMap["lost"]++;
            }

          }
        	battle_player_idx++;
      	}
        if(!playersFound) {
          continue;
        }
        count_battles++;

        // Record player associations
        battle_player_idx = battle_player_idx_first;
        while(props.jsonBattlePlayer.battle_id[battle_player_idx] === props.jsonBattles.battle_id[i]) {
          // TODO: option to do both filter and player age
       	  // if (props.jsonBattlePlayer.player_id[battle_player_idx] < player_id_min ||
          //     player_id_max < props.jsonBattlePlayer.player_id[battle_player_idx]) {
         	// 		break;
          // }

          var playerAssociationPlayer;
          if(player_team===props.jsonBattlePlayer.team_id[battle_player_idx]) {
            playerAssociationPlayer = playerAssociation[props.jsonBattlePlayer.player_id[battle_player_idx]];
            if(!playerAssociationPlayer) {
              playerAssociationPlayer = {"won":0,"lost":0};
              playerAssociation[props.jsonBattlePlayer.player_id[battle_player_idx]] = playerAssociationPlayer;
            }

            if (player_team === props.jsonBattles.team_won[i]) {
              playerAssociationPlayer["won"]++;
            } else {
              playerAssociationPlayer["lost"]++;
            }
          } else {
            // For enemies
            playerAssociationPlayer = playerAssociationEnemy[props.jsonBattlePlayer.player_id[battle_player_idx]];
            if(!playerAssociationPlayer) {
              playerAssociationPlayer = {"won":0,"lost":0};
              playerAssociationEnemy[props.jsonBattlePlayer.player_id[battle_player_idx]] = playerAssociationPlayer;
            }

            if (player_team === props.jsonBattles.team_won[i]) {
              playerAssociationPlayer["won"]++;
            } else {
              playerAssociationPlayer["lost"]++;
            }
          }
        	battle_player_idx++;
      	}
      };

      /////////////////////////////////
      // Maps asscoations

      const maxGamesMaps = Object.keys(mapAssociation).reduce(function (acc, obj) {
        const g = mapAssociation[obj].won + mapAssociation[obj].lost;
        return g>acc?g:acc;
      }, 0);
      setMaximumGamesMaps(maxGamesMaps);

      var mapAssociationRatio = Object.keys(mapAssociation).map((key) => [key, mapAssociation[key].won/(mapAssociation[key].won+mapAssociation[key].lost)]);
      mapAssociationRatio.sort((first, second) => (second[1] - first[1]));

      setRowsMaps(mapAssociationRatio.filter((e)=>{
        return (mapAssociation[e[0]].won+mapAssociation[e[0]].lost)>=minimumGamesMaps;
      }).map((e) => { return {
        id: e[0],
        map: {link:e[0], name: props.jsonMaps.name[binary_search(props.jsonMaps.map_id, e[0])]},
        won: mapAssociation[e[0]].won,
        lost: mapAssociation[e[0]].lost,
        ratio: ((e[1]*100).toFixed(2)) + "%",
      };}));

      /////////////////////////////////
      // Player asscoations team mates

      const maxGamesPlayers = Object.keys(playerAssociation).reduce(function (acc, obj) {
        const g = playerAssociation[obj].won + playerAssociation[obj].lost;
        return obj===filterBar.playerId?acc:(g>acc?g:acc);
      }, 0);
      setMaximumGamesPlayersTeammates(maxGamesPlayers);

      var playerAssociationRatio = Object.keys(playerAssociation).map((key) => [key, playerAssociation[key].won/(playerAssociation[key].won+playerAssociation[key].lost)]);
      playerAssociationRatio.sort((first, second) => (second[1] - first[1]));

      setRowsPlayersTeammates(playerAssociationRatio.filter((e)=>{
        return (playerAssociation[e[0]].won+playerAssociation[e[0]].lost)>=minimumGamesPlayersTeammates && e[0]!==filterBar.playerId;
      }).map((e) => {
        const idx = binary_search(props.jsonPlayers.player_id, e[0]);
        return {
          id: e[0],
          player: {
            id: e[0],
            nickname: props.jsonPlayers.nickname[idx],
          },
          player_nickname: props.jsonPlayers.nickname[e[0]],
          won: playerAssociation[e[0]].won,
          lost: playerAssociation[e[0]].lost,
          ratio: ((e[1]*100).toFixed(2)),
        };
      }));

      /////////////////////////////////
      // Player asscoations enemies

      const maxGamesPlayersEnemies = Object.keys(playerAssociationEnemy).reduce(function (acc, obj) {
        const g = playerAssociationEnemy[obj].won + playerAssociationEnemy[obj].lost;
        return obj===filterBar.playerId?acc:(g>acc?g:acc);
      }, 0);
      setMaximumGamesPlayersEnemies(maxGamesPlayersEnemies);

      var playerAssociationEnemyRatio = Object.keys(playerAssociationEnemy).map((key) => [key, playerAssociationEnemy[key].won/(playerAssociationEnemy[key].won+playerAssociationEnemy[key].lost)]);
      playerAssociationEnemyRatio.sort((first, second) => (second[1] - first[1]));

      setRowsPlayersEnemies(playerAssociationEnemyRatio.filter((e)=>{
        return (playerAssociationEnemy[e[0]].won+playerAssociationEnemy[e[0]].lost)>=minimumGamesPlayersEnemies && e[0]!==filterBar.playerId;
      }).map((e) => {
        const idx = binary_search(props.jsonPlayers.player_id, e[0]);
        return {
          id: e[0],
          player: {
            id: e[0],
            nickname: props.jsonPlayers.nickname[idx],
          },
          won: playerAssociationEnemy[e[0]].won,
          lost: playerAssociationEnemy[e[0]].lost,
          ratio: ((e[1]*100).toFixed(2)),
        };
      }));

      // playerAssociation can not containt the player id because it is
      // empty (for example if date range does not select any battles)
      if (filterBar.playerId && filterBar.playerId in Object.keys(playerAssociation)) {
        const w = playerAssociation[filterBar.playerId].won;
        const l = playerAssociation[filterBar.playerId].lost;
        setPlayerWonLost(", won battles: "+w+
                         ", lost battles: "+l+
                         ", ratio: "+((w/(w+l)*100).toFixed(2)) + "%");
      }

      console.log("INFO: PlayerCorrelation complete time "+(Date.now()-processingStartTimeFirst));
      return;
    }
  }, [filterBar, minimumGamesMaps, minimumGamesPlayersTeammates, minimumGamesPlayersEnemies,
      props.jsonBattlePlayer, props.jsonBattles, props.jsonGames, props.jsonMaps, props.jsonPlayers])

  useEffect(() => {
    setMinimumGamesPlayersEnemies(maximumGamesPlayersEnemies/2);
    setMinimumGamesPlayersEnemiesDisplay(maximumGamesPlayersEnemies/2);
    setMinimumGamesPlayersTeammates(maximumGamesPlayersTeammates/2);
    setMinimumGamesPlayersTeammatesDisplay(maximumGamesPlayersTeammates/2);
    setMinimumGamesMaps(maximumGamesMaps/2);
    setMinimumGamesMapsDisplay(maximumGamesMaps/2);
  }, [maximumGamesMaps, maximumGamesPlayersTeammates, maximumGamesPlayersEnemies]);
  const playerGamesMapSet = useMemo(
    () =>
      throttle((value) => setMinimumGamesMaps(value), 500),
    [],
  );

  const playerGamesPlayersTeammatesSet = useMemo(
    () =>
      throttle((value) => setMinimumGamesPlayersTeammates(value), 500),
    [],
  );

  const playerGamesPlayersEnemiesSet = useMemo(
    () =>
      throttle((value) => setMinimumGamesPlayersEnemies(value), 500),
    [],
  );

  return (
    <div>
      <Stack spacing={2}>
        <Item>
          {props.children}
        </Item>
        {Object.keys(filterBar).length>0 && <Item>
          Player ID: {filterBar.playerId} {playerWonLost}
        </Item>
        }
        <Item>
          <Stack direction="row" spacing={1}>
            <Item style={{ width: "33%" }}>
              <Typography> Show only maps on which at least an amount of games are played</Typography>
              <Slider
                onChange={(_, newValue) => { setMinimumGamesMapsDisplay(newValue); playerGamesMapSet(newValue); } }
                value={minimumGamesMapsDisplay}
                track={false}
                step={1}
                min={1}
                max={maximumGamesMaps}
                valueLabelDisplay="auto"
              />
              <div style={{ height: 600, width: '100%' }}>
               <DataGrid rows={rowsMaps} columns={columnsMaps} />
              </div>
            </Item>

            <Item style={{ width: "33%" }}>
              <Typography>
                Players that are in same team. Wins/loses when playing with
                that player in the same team. When ratio is 100% it means you always win
                when that player is in the same team as you.
              </Typography>
              <Typography> Show only players with whom at least an amount of games are played</Typography>
              <Slider
                onChange={(_, newValue) => { setMinimumGamesPlayersTeammatesDisplay(newValue); playerGamesPlayersTeammatesSet(newValue); } }
                value={minimumGamesPlayersTeammatesDisplay}
                track={false}
                step={1}
                min={1}
                max={maximumGamesPlayersTeammates}
                valueLabelDisplay="auto"
              />
              <div style={{ height: 600, width: '100%' }}>
               <DataGrid rows={rowsPlayersTeammates} columns={columnsPlayers} />
             </div>
            </Item>
            <Item style={{ width: "33%" }}>
              <Typography>
                Players that are in enemy team. Wins/loses when playing against
                that player in an enemy team. When ratio is 100% it means you always win
                when that player is in the enemy team.
              </Typography>
              <Typography> Show only players against whom at least an amount of games are played</Typography>
              <Slider
                onChange={(_, newValue) => { setMinimumGamesPlayersEnemiesDisplay(newValue); playerGamesPlayersEnemiesSet(newValue); } }
                value={minimumGamesPlayersEnemiesDisplay}
                track={false}
                step={1}
                min={1}
                max={maximumGamesPlayersEnemies}
                valueLabelDisplay="auto"
              />
              <div style={{ height: 600, width: '100%' }}>
               <DataGrid rows={rowsPlayersEnemies} columns={columnsPlayers} />
             </div>
            </Item>

          </Stack>
        </Item>
      </Stack>
    </div>
  );
}

PlayerCorrelation.propTypes = {
  jsonBattles: PropTypes.object,
  jsonBattlePlayer: PropTypes.object,
  jsonGames: PropTypes.object,
  jsonMaps: PropTypes.object,
  jsonPlayers: PropTypes.object,
  filterBarValues: PropTypes.object,  
};

export default PlayerCorrelation;
